import axios from 'axios';
import $i18n from '@/i18n';
const i18n: any = $i18n.global;

// timeout for invoice status = 900sec in ms
const INVOICE_STATUS_TIMEOUT = 900000;
const RESPONSE_CODE_OK = 0;
const PENDING_ORDER = 2;

export default {
  namespaced: true,
  state: {
    inProgress: false,
    invoiceStatus: null,
    lastUpdate: new Date(0)
  },
  mutations: {
    setInvoiceStatus(state:any, newInvoiceStatus: any) {
      state.lastUpdate = Date.now();
      state.invoiceStatus = newInvoiceStatus;
    },
    setInProgress(state: any, newValue: boolean) {
      state.inProgress = newValue;
    },
    removeInvoiceStatus(state: any) {
      state.invoiceStatus = null;
    }
  },
  getters: {
    inProgress(state: any) {
      return state.inProgress;
    },
    invoiceStatus(state: any) {
      return state.invoiceStatus;
    },
  },
  actions: {
    refreshInvoiceStatus(context: any, axios: any) {

      if (context.getters.status && (context.getters.lastUpdate + INVOICE_STATUS_TIMEOUT > Date.now())) {
        //there is no need to refresh profile data
        return;
      } else {
        // we have outdated data, remove old one so we do not show it while loading new data
        context.commit("removeInvoiceStatus");
      }

      context.commit("setInProgress", true);
      axios.get('/api/user/invoice')
        .then(
          response => {
            if (response && response.data && response.data.responseCode === RESPONSE_CODE_OK) {
              context.commit("setInvoiceStatus", response.data);
            } else {
              context.rootState.errorMessage = i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE");
              context.rootState.setErrorMessageCalled++;
            }
          }
        ).catch( callData => {
          if (callData.response.data.responseCode == PENDING_ORDER) {
            context.rootState.warningMessage = i18n.t("INVOICE_CHECKBOX.IN_PROGRESS");
            context.rootState.setWarningMessageCalled++;
          } else {
            context.rootState.errorMessage = i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE");
            context.rootState.setErrorMessageCalled++;
          }
        })
        .finally(
        () => {
          context.commit("setInProgress", false);
        }
      )
    }
  }
}
